/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../store'

/**
 * Import
 * - Actions
 */
import { getFullQuoteRenewal } from '../../../../actions'

/**
 * Import
 * - Page component
 */
import EditRenewals from '../../../../components/pages/Renewals/EditRenewals/EditRenewals'

const mapStateToProps = (state: RootState) => {
    return {
        quote: state.quote,
    }
}

export default connect(
    mapStateToProps,
    {
        getFullQuoteRenewal: getFullQuoteRenewal,
    }
)(EditRenewals)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Renewals/EditRenewals/EditRenewals.tsx